import React, { useState } from 'react';
import Card from 'components_v2/common/CardV7/Card';
import Loader from 'components/Loader';
import AdCaller from 'helpers/ads/adCaller';
import makeRequest from 'utils/makeRequest';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import s from './TileMoreStories.scss';

const TileMoreStories = props => {
  const { data } = props;

  if (
    !(
      props.data &&
      props.data.items &&
      Array.isArray(props.data.items) &&
      props.data.items.length > 0
    )
  ) {
    return null;
  }

  const [loaderShow, setloaderShow] = useState(false);
  const [moreDataUrl, setMoreDataUrl] = useState(
    data && data.pagination && data.pagination.nextPageUrl,
  );
  const [storyItems, setStoryItems] = useState([...data.items]);

  //   const perpageItems =
  //     data && data.pagination && data.pagination.perpage
  //       ? parseInt(data.pagination.perpage, 10)
  //       : 30;

  const { isPrime } = props;
  let jarvisAdCounter = 0;
  const maxCounter = 9;

  const adConfig = {
    tn: 'ad',
    adtype: 'dfp',
  };

  const loadMoreData = () => {
    if (moreDataUrl) {
      setloaderShow(true);

      makeRequest
        .get(moreDataUrl, { isMobile: true }, 'skipfeedengine')
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.items &&
            response.data.items.length > 0
          ) {
            if (
              typeof window !== 'undefined' &&
              response.data.pagination.cp &&
              response.data.pagination.cp > 1 &&
              response.data.pagination?.leafNode
            ) {
              let location = window.location.pathname;
              if (location.endsWith(`/${response.data.pagination.cp - 1}`)) {
                location = location.replace(
                  new RegExp(`/${response.data.pagination.cp - 1}$`),
                  `/${response.data.pagination.cp}`,
                );
              } else {
                location += `/${response.data.pagination.cp}`;
              }
              const query = window.location.search
                ? window.location.search
                : '';
              location = window.location.origin + location + query;
              window.history.pushState({}, '', location);
              analyticsWrapper(
                'gaAndGrx',
                'send',
                'pageview',
                window.location.href,
              );
            }
            setStoryItems([...storyItems, ...response.data.items]);
            setMoreDataUrl(
              response.data.pagination && response.data.pagination.nextPageUrl
                ? response.data.pagination.nextPageUrl
                : '',
            );

            // this.setState({
            //   moreData: this.state.moreData.concat(response.data.items),
            //   paginationData: response.data.pagination,
            //   paginationUrl: response.data.pagination.nextPageUrl
            //     ? response.data.pagination.nextPageUrl
            //     : '',
            // });
            setloaderShow(false);
          } else {
            setloaderShow(false);
          }
        });
    }
  };

  const renderedStoryItems = storyItems || data.items;

  return (
    <>
      <div className={s.cardListWrapper}>
        {/* className="vertical_12 m_1 left_spacing right_spacing bottom_v_spacing b_brdr brdr_2"> */}
        {renderedStoryItems.map((item, index) => {
          let adComponent = null;
          if (
            !isPrime &&
            (index + 1) % 5 === 0 &&
            index + 1 !== props.data.items.length
          ) {
            const adName = `mrec${jarvisAdCounter > 0 ? jarvisAdCounter : ''}`;
            jarvisAdCounter += 1;
            if (jarvisAdCounter > maxCounter) {
              jarvisAdCounter = 5;
            }
            adComponent = (
              <div className={`${s.brdr_skip} paisa-wrapper mrec_placeHolder`}>
                <AdCaller
                  data={{
                    ...adConfig,
                    name: adName,
                  }}
                  msid={`${item.id}-${index}`}
                  immediateLoad
                />
              </div>
            );
          }

          let layoutValue = 'card_7';

          if (index === 0) {
            const hasLeadImage =
              data?.leadImage !== undefined &&
              data?.leadImage !== null &&
              data?.leadImage === 'true';

            layoutValue = hasLeadImage ? 'card_7' : 'card_6';
          }

          const storyComponent = (
            <div className={index === 0 || adComponent ? s.brdr_skip : ''}>
              <Card
                data={item}
                layout={layoutValue}
                shouldNotlazyloadImage={index === 0}
              />
            </div>
          );

          return (
            <>
              {storyComponent}
              {adComponent}
            </>
          );
        })}
      </div>
      {!loaderShow &&
        moreDataUrl && (
          <button
            // eslint-disable-next-line react/jsx-no-bind
            onClick={loadMoreData}
            className={s.loadMore}
          >
            Load More
            <i />
          </button>
        )}
      {loaderShow && (
        <div className={s.loaderSpacing}>
          <Loader />
        </div>
      )}
    </>
  );
};

export default TileMoreStories;
